<template>
  <v-dialog
    v-model="iconDialog"
    max-width="600">
    <IconPicker
      @close="iconDialog = false"
      @select="updateIcon" />
  </v-dialog>
  <div style="display: flex; flex-direction: column">
    <v-card
      style="
        display: flex;
        justify-content: center;
        overflow: hidden;
        flex-direction: column;
      "
      flat
      class="mt-3">
      <v-img
        class="hello"
        v-if="userEditObj.thumbnail"
        height="100"
        dark
        style="
          border-radius: 4px;
          overflow: hidden;
          background-clip: context-box;
          background: #5c5c5d;
          justify-content: end;
          display: flex;
        "
        :src="userEditObj.thumbnail">
        <v-btn
          @click="
            userEditObj.thumbnail = null;
            thumbnailEdited = true;
          "
          class="ma-3"
          variant="flat">
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </v-img>
      <input
        id="uploadThumbnail"
        type="file"
        accept="image/*"
        style="display: none"
        @input="updateThumbnail" />
      <v-btn
        @click="openFileInput"
        variant="tonal">
        Upload Thumbnail
      </v-btn>
    </v-card>
    <v-card
      style="display: flex; justify-content: center"
      flat
      class="mt-5">
      <div style="display: flex">
        <div
          class="pa-3"
          style="background: #2d2d2d; border-radius: 7px">
          <v-icon
            color="white"
            size="x-large">
            {{ userEditObj.icon }}
          </v-icon>
        </div>
        <v-btn
          class="ml-3"
          prepend-icon="mdi-swap-horizontal"
          @click="iconDialog = true"
          variant="tonal">
          Change Icon
        </v-btn>
      </div>
    </v-card>
    <v-card
      class="my-3"
      flat
      v-if="userEditObj.files">
      <v-card-title>
        {{ userEditObj.files.length }} Included Files:
      </v-card-title>

      <v-list-item
        v-for="file in userEditObj.files"
        :key="file"
        two-line>
        <v-list-item-content>
          <v-list-item-title>
            {{ file.replace(/^.*[\\\/]/, '') }}
          </v-list-item-title>
          <v-list-item-subtitle>{{ file }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-card>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import IconPicker from '../../Shared/IconPicker.vue';
const iconDialog = ref(false);
const thumbnailEdited = ref(false);
const iconChanged = ref(false);

const props = defineProps(['userEditObj']);

function updateIcon(icon) {
  props.userEditObj.icon = icon;
  iconChanged.value = true;
}

function openFileInput() {
  document.getElementById('uploadThumbnail').click();
}

function updateThumbnail(evt) {
  var tgt = evt.target || window.event.srcElement,
    files = tgt.files;

  // FileReader support
  if (FileReader && files && files.length) {
    var fr = new FileReader();
    fr.onload = () => {
      thumbnailEdited.value = true;
      props.userEditObj.thumbnail = fr.result;
    };
    fr.readAsDataURL(files[0]);
  }
}
</script>

<style scoped></style>
